<template>
    <div class="permisos" >
        <div v-if="tablaIndividual.length > 1">
            <vs-row v-if="tablaIndividual.length > 1" class="card mt-4">
                <vs-col w="12">
                    <div class="chart-container card-body">
                        <!-- <v-bar-chart :chart-data="fillData(graph)" :options="optionsGraph()"></v-bar-chart> -->
                        <v-horizontal-bar-chart :chart-data="fillData(graph)" :options="optionsGraph()">
                        </v-horizontal-bar-chart>
                        <!-- <v-line-chart :chart-data="fillData(graph)" :options="optionsGraph()"></v-line-chart> -->
                    </div>
                </vs-col>
            </vs-row>
            <div class="card mt-4 p-3" v-if="tablaIndividual.length">
                <details class="card-body">
                    <summary><strong>USABILIDAD INDIVIDUAL</strong></summary>
                    <vs-row class="p-2 mt-3" v-if="tablaIndividual.length">
                        <vs-col sm="12" lg="6" class="ml-auto">
                            <vs-input v-model="search" placeholder="Buscar institución">
                                <template #icon>
                                    <i class="fas fa-search"></i>
                                </template>
                            </vs-input>
                        </vs-col>
                    </vs-row>
                    <vs-row>
                        <vs-col sm="12" :lg="tablaIndividual.length == 1 ? '12' : '6'" v-for="(info, g) in  $vs.getSearch(tablaIndividual, search)" :key="g" class="p-2">
                            <vs-row class="card mt-3 p-4">
                                <vs-col w="12">
                                    <h5><strong>{{ info.institucion }}</strong></h5>
                                </vs-col>
                                <vs-col>
                                    
                                    <div class="card-body p-3">
                                        <h2 class="m-0 pr-2">{{info.porcentaje_usabilidad}} <small>/ 100</small></h2>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="w-100">
                                                <div class="progress">
                                                    <div class="progress-bar" :class="getColorPorcentaje(info.porcentaje_usabilidad)" role="progressbar" :style="'width:' + info.porcentaje_usabilidad + '%'" 
                                                        aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p class="m-0">Porcentaje de usabilidad</p>
                                    </div>
                                </vs-col>
                                <vs-col sm="12" :lg="graph.length == 1 ? '4' : '12'">
                                    <table>
                                        <tr>
                                            <th>MÓDULO</th>
                                            <th>STATUS</th>
                                            <th>PONDERACIÓN</th>
                                        </tr>
                                        <tr v-for="(individual, i) in info.usabilidad" :key="i">
                                            <td>{{individual.titulo}}</td>
                                            <td>
                                                <md-chip class="mb-1 fontMedium mini-chip" :class="individual.status == true ? 'col-green' : 'col-yellow'" ><strong> {{getEstatus(individual.status, individual.titulo)}}  </strong></md-chip>
                                            </td>
                                            <td class="text-center">{{individual.ponderacion}} %</td>
                                        </tr>
                                    </table>
                                </vs-col>
                            </vs-row>
                        </vs-col>
                    </vs-row>
                </details>
            </div>
        </div>
        <div v-else class="mt-4">
            <div class="card">
                <vs-row class="card-body" v-if="tablaIndividual.length">
                    <vs-col sm="12" :lg="tablaIndividual.length == 1 ? '12' : '6'" v-for="(info, g) in  $vs.getSearch(tablaIndividual, search)" :key="g" class="p-2">
                        <vs-row class="card mt-3 p-4">
                            <vs-col w="12">
                                <h5><strong>{{ info.institucion }}</strong></h5>
                            </vs-col>
                            <vs-col>
                                
                                <div class="card-body p-3">
                                    <h2 class="m-0 pr-2">{{info.porcentaje_usabilidad}} <small>/ 100</small></h2>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="w-100">
                                            <div class="progress">
                                                <div class="progress-bar" :class="getColorPorcentaje(info.porcentaje_usabilidad)" role="progressbar" :style="'width:' + info.porcentaje_usabilidad + '%'" 
                                                    aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="m-0">Porcentaje de usabilidad</p>
                                </div>
                            </vs-col>
                            <vs-col sm="12" :lg="graph.length == 1 ? '4' : '12'">
                                <table>
                                    <tr>
                                        <th>MÓDULO</th>
                                        <th>STATUS</th>
                                        <th>PONDERACIÓN</th>
                                    </tr>
                                    <tr v-for="(individual, i) in info.usabilidad" :key="i">
                                        <td>{{individual.titulo}}</td>
                                        <td>
                                            <md-chip class="mb-1 fontMedium mini-chip" :class="individual.status == true ? 'col-green' : 'col-yellow'" ><strong> {{getEstatus(individual.status, individual.titulo)}} </strong></md-chip>
                                        </td>
                                        <td class="text-center">{{individual.ponderacion}} %</td>
                                    </tr>
                                </table>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                </vs-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:[
        'graph',
        'tablaIndividual'
    ],
    data() { 
        return {
            search: '',
        }
    },
    methods:{
        getColorPorcentaje(porcentaje){
            if(porcentaje < 34){
                return 'bg-warning'
            }else if(porcentaje < 67){
                return 'bg-primary'
            }else{
                return 'bg-success'
            }
        },
        getEstatus(status, titulo){
            if(status == true){
                if(titulo == 'Calificaciones'){
                    return 'Capturado'
                }else{
                    return 'Configurado'
                }
            }else{
                if(titulo == 'Calificaciones'){
                    return 'Sin capturar'
                }else{
                    return 'Sin configurar'
                }
            }
        },
        fillData({institucion, labels, porcentaje}) {
                return {
                    labels: labels,
                    datasets: [{
                        label: 'Porcentaje',
                        backgroundColor: "rgba(36,113,163,1)",
                        // borderColor: "rgba(36,113,163,0.2)",
                        barThickness: 'flex',
                        maxBarThickness: 50,
                        hoverBackgroundColor: "rgba(36,113,163,0.4)",
                        // hoverBorderColor: "rgba(36,113,163,0.4)",
                        data: porcentaje,
                    }]
                }
        },
        optionsGraph(){
            return {
                legend: {
                    display: false
                },
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        display: true,
                        gridLines: {
                            display: true,
                            color: "rgba(255,99,132,0.2)"
                        },
                        ticks: {
                            suggestedMin: 0,
                            suggestedMax: 100,
                            beginAtZero: true,
                            callback: function(value, index, ticks) {
                                return value + '%';
                            },
                        }
                    }],
                    yAxes: [{
                        display: true,
                        gridLines: {
                            display: false,
                            color: "rgba(255,99,132,0.2)"
                        },
                    }]
                },
            }
        }
    }
}
</script>

<style scoped>

.chart-container {
  position: relative;
  margin: auto;
  height: auto;
  width: auto;
}
table {
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border-bottom: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
</style>

<style lang="scss" scoped>

@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);
    @include text-colors ('yellow', #febf3d, #fff8ec);  
}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);   
    @include text-colors ('yellow', #febf3d, #fff8ec);  
}
</style>

<style lang="scss" scoped>
.permisos{
    .encabezado{
        border-radius: 14px 14px 0 0;
        background: #F4F7F8;
        padding: 10px 12px;
    }
    .sinInfo{
        padding: 20px;
        text-align: center;
    }
    details{
        padding: 10px 12px;
    }
    details:not(:last-child){
        border-bottom: 2px solid #ececec;
    }
    details summary{
    font-size: 22px;
    }
}
</style>
<style>
.permisos div.vs-table-content > div.vs-table > table{
        margin: 0 auto !important;
        width: 98% !important;
}
</style>